
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.5996 3.05358C11.8063 3.05358 3.05651 11.8033 3.05651 22.5967C3.05651 33.39 11.8063 42.1398 22.5996 42.1398C33.393 42.1398 42.1427 33.39 42.1427 22.5967C42.1427 11.8033 33.393 3.05358 22.5996 3.05358ZM0.0996094 22.5967C0.0996094 10.1703 10.1732 0.0966797 22.5996 0.0966797C35.026 0.0966797 45.0996 10.1703 45.0996 22.5967C45.0996 35.023 35.026 45.0967 22.5996 45.0967C10.1732 45.0967 0.0996094 35.023 0.0996094 22.5967ZM22.5972 12.6557C23.4137 12.6557 24.0757 13.3176 24.0757 14.1341V22.9602C24.0757 23.7767 23.4137 24.4387 22.5972 24.4387C21.7807 24.4387 21.1188 23.7767 21.1188 22.9602V14.1341C21.1188 13.3176 21.7807 12.6557 22.5972 12.6557ZM23.3776 29.7979C24.0727 30.2263 24.2891 31.1372 23.8608 31.8323L23.8559 31.84C23.4275 32.535 22.5168 32.7515 21.8217 32.3231C21.1264 31.8948 20.9102 30.984 21.3386 30.2888L21.3433 30.2811C21.7716 29.586 22.6826 29.3696 23.3776 29.7979Z","fill":"#F9782F"}})])
          )
        }
      }
    